export const captcha = {
    methods: {
        refreshTokenCallMethod (acao, metodo) {
            grecaptcha.ready(() => {
                grecaptcha.execute('6Lf1L8QUAAAAAMu6l_qoyHB89w1M0eYlntrV6Nge', {action: acao}).then((token) => {
                    this.$store.commit('sessao/setCaptcha', token)
                    this[metodo]()
                });
            });
        }
    }
}